import { render, staticRenderFns } from "./UiCommentsFrameList.vue?vue&type=template&id=2562e1f7"
import script from "./UiCommentsFrameList.vue?vue&type=script&lang=js"
export * from "./UiCommentsFrameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports